import { useErrorMessage } from "~/composables/useErrorMessage";

/**
 * Wraps an async function in a try catch block that displays an error message
 * the caller might optionally catch the error
 *
 * try {
 *   const {data} = await withErrorMessage(findUser(params))
 *   this.authUser = data;
 * } catch (err) {
 *   console.log('Optional additional handling')
 * }
 *
 * @param promise
 */
export async function withErrorMessage<T>(promise: Promise<T>): Promise<T> {
  const errorHandler = useErrorMessage();

  try {
    return await promise;
  } catch (err) {
    errorHandler(err);
    throw err;
  }
}
